import { render, staticRenderFns } from "./BvaNoticeDetail.vue?vue&type=template&id=aa6af8da&"
import script from "./BvaNoticeDetail.vue?vue&type=script&lang=ts&"
export * from "./BvaNoticeDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports